import { render, staticRenderFns } from "./BindForm.vue?vue&type=template&id=3a94f24a&scoped=true"
import script from "./BindForm.vue?vue&type=script&lang=js"
export * from "./BindForm.vue?vue&type=script&lang=js"
import style0 from "./BindForm.vue?vue&type=style&index=0&id=3a94f24a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a94f24a",
  null
  
)

export default component.exports